module.exports = __webpack_public_path__ + "img/trial-new-banner.426b0b5b.jpg";